import { useState } from "react";
import { ThemeProvider } from "styled-components";
import { GlobalStyles } from "./components/GlobalStyles";
import { themes } from "./themes/Themes";
import useCurrentTheme from "./hooks/useCurrentTheme";
import { difficultyLevels } from "./data";
import { formatNumDecimalPoint } from "./helpers";
import Header from "./components/Header";
import TypingArea from "./components/TypingArea";
import Pointers from "./components/Pointers";
import Footer from "./components/Footer";

function App() {
  const [theme, themeToggler] = useCurrentTheme(),
    themeMode = themes.find((t) => t.name === theme);
  const [difficulty, setDifficulty] = useState(difficultyLevels[0]),
    [time, setTime] = useState(formatNumDecimalPoint(difficulty.limit, 2));
  return (
    <ThemeProvider theme={themeMode}>
      <>
        <GlobalStyles />
        <div className="container md:w-3/4 w-full h-auto mx-auto">
          <Header
            themeToggler={themeToggler}
            themes={themes}
            activeId={themeMode.id}
            difficulty={difficulty}
            setDifficulty={setDifficulty}
            difficultyLevels={difficultyLevels}
            setTime={setTime}
          />
          <main className="max-w-6xl mx-auto mt-9">
            <TypingArea difficulty={difficulty} time={time} setTime={setTime} />
            <Pointers />
            <Footer />
          </main>
        </div>
      </>
    </ThemeProvider>
  );
}

export default App;
